cb.define(['common/common_VM.Extend.js'], function (common) {
  var ST_st_storeout_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
    	
    	var detailsModel = viewmodel.get("details");
    	
			if(detailsModel){
				//向后台传递行号
				detailsModel.setState('orderField', 'rowno');
				//单元格编辑之前判断该行商品是否启用批次管理和效期管理
				detailsModel.on('rowColChange', function(args) {
					return common.bacthnoAndExpiryDateManage(args, detailsModel);
				});
				//批次参照弹出前事件，看一下商品是否启用批次管理，如果未启用，那么不弹出批次参照
				detailsModel.on('beforeBrowse', function(args) {
					if(args.cellName == 'batchno'){
						var rows = detailsModel.getRows();
						var rowIndex = args.rowIndex;
						var row = rows[rowIndex];
						if(row.isBatchManage == true){

						}else{
							return false;
						}
					}
				});
				//单元格值改变以后，如果是商品变了，就清空批次号、生效日期、失效日期
				// detailsModel.on('afterCellValueChange', function (data){
				// 	switch (data.cellName) {
				// 		case "product_cCode" : {
				// 			detailsModel.setCellValue(data.rowIndex, 'batchno', null);
				// 			detailsModel.setCellValue(data.rowIndex, 'producedate',  null);
				// 			detailsModel.setCellValue(data.rowIndex, 'invaliddate',  null);
				// 			//detailsModel.setCellValue(data.rowIndex, 'invaliddate',  null);
				// 			//detailsModel.setCellValue(data.rowIndex, 'invaliddate',  null);
				// 			break;
				// 		}
				// 	}
				// })
				//单元格值改变以后，如果是商品变了，就清空批次号、生效日期、失效日期、批次属性、商品自定义项
				//（sku自定义项是参照带出来的，商品清空就会跟着清空，不许需要在这里处理）
				detailsModel.on('afterCellValueChange', function (data){
					switch (data.cellName) {
						case "productsku_cCode":
						case "productsku_cName":
						case "product_cName" :
						case "product_cCode" : {
							detailsModel.setCellValue(data.rowIndex, 'batchno', null);
							detailsModel.setCellValue(data.rowIndex, 'producedate',  null);
							detailsModel.setCellValue(data.rowIndex, 'invaliddate',  null);
							for(var i = 1; i <= 30 ; i ++)
							{
								detailsModel.setCellValue(data.rowIndex, 'define'+i, null);
								detailsModel.setCellValue(data.rowIndex, 'prodefine'+i, null);						
							}
							break;
						}
						//单元格值改变以后，如果是批号变了，就清空商品自定义项
						//（批次号、生效日期、失效日期、批次属性、sku自定义项是批次参照带出来的，批次就会跟着清空，不许需要在这里处理）
						case "batchno" : {				
							for(var i = 1; i <= 30 ; i ++)
							{
								detailsModel.setCellValue(data.rowIndex, 'prodefine'+i, null);						
							}
							break;
						}
					}
				});
			}
			//生成店存出库单
			var self = this;
			viewmodel.on('afterLoadData', function (data){
				var detailsModel = viewmodel.get("details");
				var mode = viewmodel.getParams().mode;
				var logisticsModel = viewmodel.get("OutStoreLogistics");
				logisticsModel.on('afterMount', function() {
					//编辑态
					if(mode == 'edit'){
							//设置商品表体行不可删除
							/*var actionsStates = [];
							var rows = detailsModel.getRows();
							for(var i = 0; i < rows.length ; i ++ ){
								var actionState = {};
								actionState["btnDeleteRow2"] = {visible:false};
								actionsStates.push(actionState);
							}
							logisticsModel.setActionsState(actionsStates);*/
							
					}
					else if (mode == 'add'){
						
					}
					//浏览态
					else{
							//设置商品表体行不可删除
							var actionsStates = [];
							var rows = detailsModel.getRows();
							for(var i = 0; i < rows.length ; i ++ ){
								var actionState = {};
								actionState["btnDeleteRow2"] = {visible:false};
								actionsStates.push(actionState);
							}
							
							logisticsModel.setActionsState(actionsStates);
					}
				});	
				
				
				//新增态
				if(mode=="add"){
					viewmodel.get('inWarehouse_name').setDisabled(data.inStore_name ? false : true);
					self.queryCentStoreGroup(cb.rest.AppContext.user.storeId,viewmodel);
					viewmodel.get("btnAddRow2").setVisible(true);
					viewmodel.get("btnAddRow2").setDisabled(false);
					if (data.srcBill !=null ){
						if(data.srcBillType == "1"){
							self.queryBusytype(1,viewmodel);
							viewmodel.get("inWarehouse_name").setReadOnly(true);
						}else if (data.srcBillType == "2"){
							//退货类型，仓库过滤成业务仓
							self.setWarehouseFilter(viewmodel);
							//业务类型，过滤成只可选退货类型
							self.queryBusytype(2,viewmodel);
						}
						
						//设置商品表体行不可删除
						var actionsStates = [];
						var rows = detailsModel.getRows();
						rows.forEach(data =>{
							var actionState = {};
							actionState["btnDeleteRow"] = {visible:false};
							actionsStates.push(actionState);
						});
						detailsModel.setActionsState(actionsStates);
						
						//viewmodel.get("vouchdate").setReadOnly(true);
						viewmodel.get("code").setVisible(true);
						//viewmodel.get("outWarehouse_name").setReadOnly(true);
						viewmodel.get("inStore_name").setReadOnly(true);
						
						//viewmodel.get("operator_name").setReadOnly(true);
						viewmodel.get("srcBillNO").setReadOnly(true);
						viewmodel.get("status").setReadOnly(true);
						viewmodel.get("btnAudit").setVisible(false);
						viewmodel.get("btnAddRow").setVisible(false);
						viewmodel.get("btnDeleteRow").setVisible(false);
						viewmodel.get("btnDeleteRow").setDisabled(true);
						rows.forEach(function(rows,index){
							detailsModel.setCellState(index, 'product_cName', 'disabled', true);
							detailsModel.setCellState(index, 'product_cCode', 'disabled', true);
							detailsModel.setCellState(index, 'free1', 'disabled', true);
							detailsModel.setCellState(index, 'free2', 'disabled', true);
							detailsModel.setCellState(index, 'free3', 'disabled', true);
							detailsModel.setCellState(index, 'free4', 'disabled', true);
							detailsModel.setCellState(index, 'free5', 'disabled', true);
							detailsModel.setCellState(index, 'free6', 'disabled', true);
							detailsModel.setCellState(index, 'free7', 'disabled', true);
							detailsModel.setCellState(index, 'free8', 'disabled', true);
							detailsModel.setCellState(index, 'free9', 'disabled', true);
							detailsModel.setCellState(index, 'free10', 'disabled', true);
	//						detailsModel.setCellState(index, 'recorddate', 'disabled', true);
							detailsModel.setCellState(index, 'invaliddate', 'disabled', true);
							detailsModel.setCellState(index, 'producedate', 'disabled', true);
							detailsModel.setCellState(index, 'quantity', 'disabled', true);
							detailsModel.setCellState(index, 'unitName', 'disabled', true);
	//						detailsModel.setCellState(index, 'memo', 'disabled', true);
	//						detailsModel.setCellState(index, 'unitName', 'disabled', true);
	//						detailsModel.setCellState(index, 'unitName', 'disabled', true);
	//						detailsModel.setCellState(index, 'unitName', 'disabled', true);
	//						detailsModel.setCellState(index, 'unitName', 'disabled', true);
	//						detailsModel.setCellState(index, 'unitName', 'disabled', true);
	//						detailsModel.setCellState(index, 'unitName', 'disabled', true);
							
	//						detailsModel.setCellState(index, 'batchno', 'disabled', true);
	//						detailsModel.setCellState(index, 'rowno', 'disabled', true);
						});					
					}
					
				}
				//编辑态
				else if(mode == 'edit'){
					self.queryCentStoreGroup(cb.rest.AppContext.user.storeId,viewmodel);
					viewmodel.get("btnDeleteRow2").setVisible(true);
					viewmodel.get("btnAddRow2").setVisible(true);
					viewmodel.get("btnDeleteRow2").setDisabled(false);
					viewmodel.get("btnAddRow2").setDisabled(false);

					if (data.srcBill !=null ){
						//设置商品表体行不可删除
						var actionsStates = [];
						var rows = detailsModel.getRows();
						for(var i = 0; i < rows.length ; i ++ ){
							var actionState = {};
							actionState["btnDeleteRow"] = {visible:false};
							actionsStates.push(actionState);
						}
						
						detailsModel.setActionsState(actionsStates);
						
						//viewmodel.get("vouchdate").setReadOnly(true);
						viewmodel.get("code").setVisible(true);
						viewmodel.get("outWarehouse_name").setReadOnly(true);
						viewmodel.get("inStore_name").setReadOnly(true);
						viewmodel.get("inWarehouse_name").setReadOnly(true);
						//viewmodel.get("operator_name").setReadOnly(true);
						viewmodel.get("srcBillNO").setReadOnly(true);
						viewmodel.get("status").setReadOnly(true);
						viewmodel.get("btnAudit").setVisible(false);
						viewmodel.get("btnAddRow").setVisible(false);
						viewmodel.get("btnDeleteRow").setDisabled(true);
						viewmodel.get("btnDeleteRow").setVisible(false);
						//viewmodel.get("btnDeleteRow").setDisabled(true);
						//viewmodel.get("btnDeleteRow").setVisible(false);
						rows.forEach(function(rows,index){
							detailsModel.setCellState(index, 'product_cName', 'disabled', true);
							detailsModel.setCellState(index, 'product_cCode', 'disabled', true);
							detailsModel.setCellState(index, 'free1', 'disabled', true);
							detailsModel.setCellState(index, 'free2', 'disabled', true);
							detailsModel.setCellState(index, 'free3', 'disabled', true);
							detailsModel.setCellState(index, 'free4', 'disabled', true);
							detailsModel.setCellState(index, 'free5', 'disabled', true);
							detailsModel.setCellState(index, 'free6', 'disabled', true);
							detailsModel.setCellState(index, 'free7', 'disabled', true);
							detailsModel.setCellState(index, 'free8', 'disabled', true);
							detailsModel.setCellState(index, 'free9', 'disabled', true);
							detailsModel.setCellState(index, 'free10', 'disabled', true);
	//						detailsModel.setCellState(index, 'recorddate', 'disabled', true);
							detailsModel.setCellState(index, 'invaliddate', 'disabled', true);
							detailsModel.setCellState(index, 'producedate', 'disabled', true);
							detailsModel.setCellState(index, 'quantity', 'disabled', true);
							detailsModel.setCellState(index, 'unitName', 'disabled', true);
	//						detailsModel.setCellState(index, 'memo', 'disabled', true);
	//						detailsModel.setCellState(index, 'unitName', 'disabled', true);
	//						detailsModel.setCellState(index, 'unitName', 'disabled', true);
	//						detailsModel.setCellState(index, 'unitName', 'disabled', true);
	//						detailsModel.setCellState(index, 'unitName', 'disabled', true);
	//						detailsModel.setCellState(index, 'unitName', 'disabled', true);
	//						detailsModel.setCellState(index, 'unitName', 'disabled', true);
							
	//						detailsModel.setCellState(index, 'batchno', 'disabled', true);
	//						detailsModel.setCellState(index, 'rowno', 'disabled', true);
						});					
					}
				}else{
					viewmodel.get("btnAddRow2").setVisible(false);
				}
			});	
			
			
			
			//保存之前，校验出库仓库和入库仓库不可以相同
			viewmodel.on('beforeSave', function(args) {
				//校验出库数量必须大于零
				var detailsModel = viewmodel.get("details");
				var rows = detailsModel.getRows();

				
				var outWarehouse = viewmodel.get("outWarehouse").getValue();
				var inWarehouse = viewmodel.get("inWarehouse").getValue();
				var outStore = viewmodel.get("outStore").getValue();
				var inStore = viewmodel.get("inStore").getValue();
				var bustype_storeOutType = viewmodel.get("bustype_storeOutType").getValue();
				
				if(bustype_storeOutType == "1") {
					if(inStore == undefined || inStore == ""){
						cb.utils.alert("业务类型为调拨出库时，入库门店不可为空！");
						return false;
					}
					if(inWarehouse == undefined || inWarehouse == ""){
						cb.utils.alert("业务类型为调拨出库时，入库仓库不可为空！");
						return false;
					}
				}else if(bustype_storeOutType == "2"){
					if(inWarehouse == undefined || inWarehouse == ""){
						cb.utils.alert("业务类型为退货出库时，入库仓库不可为空！");
						return false;
					}
				}
				if(outWarehouse == inWarehouse) {
					cb.utils.alert("出库仓库和入库仓库不可以相同！");
					return false;
				}
				for(var i = 0; i < rows.length ; i ++){
					if(rows[i].quantity <= 0){
						cb.utils.alert("商品出库数量必须大于零！");
						return false;
					}
				}
				

			});		
			
			//选择仓库之前，如果没有选择入库门店，提示请先选择
			viewmodel.get("inWarehouse_name").on('beforeBrowse', function(data) {
				var bustype_name = viewmodel.get("bustype_name").getValue();
				if(bustype_name == null || bustype_name == "") {
					cb.utils.alert("请先选择业务类型！");
					return false;
				} else {
					var bustype_storeOutType = viewmodel.get("bustype_storeOutType").getValue();
					if(bustype_storeOutType == 1){
						var inStore_name = viewmodel.get("inStore_name").getValue();
						if(inStore_name == null || inStore_name == "") {
							cb.utils.alert("调拨出库，请先选择入库门店！");
							return false;
						} else {
							viewmodel.get('inWarehouse_name').setDisabled(false);
						}
					}
					
				}
					
			});
			//选择门店前，要先选择业务类型
			viewmodel.get("inStore_name").on('beforeBrowse', function(data) {
				var bustype_name = viewmodel.get("bustype_name").getValue();
				if(bustype_name == null || bustype_name == "") {
					cb.utils.alert("请先选择业务类型！");
					return false;
				} else {
					viewmodel.get('inStore_name').setDisabled(false);
				}
			});
			
			//当业务类型是退货申请时，仓库过滤为周边门店业务仓
			viewmodel.get("bustype_name").on('afterValueChange', function(data) {
				viewmodel.get("inStore_name").setValue("");
				viewmodel.get("inWarehouse_name").setValue("");
				viewmodel.get("inOrg_name").setValue("");
				viewmodel.get('inWarehouse_name').setState('bIsNull', true)
				viewmodel.get('inStore_name').setState('bIsNull', true)
				var bustype_name = viewmodel.get("bustype_name").getValue();
				if(viewmodel.get("srcBillNO").getValue() == "" || viewmodel.get("srcBillNO").getValue() == null){
					if(bustype_name == "" || bustype_name == null){
						if(viewmodel.get("srcBillNO").getValue() != null && viewmodel.get("srcBillNO").getValue() != ""){
							viewmodel.get("inStore_name").setValue("");
							viewmodel.get("inStore").setValue("");
							viewmodel.get("inWarehouse_name").setValue("");
							viewmodel.get("inWarehouse").setValue("");
							//viewmodel.get("inOrg").setValue("");
							//viewmodel.get("inOrg_name").setValue("");
						}
					}
				}
				
				var bustype_storeOutType = viewmodel.get("bustype_storeOutType").getValue();
				if(bustype_storeOutType == 2){
					viewmodel.get('inWarehouse_name').setState('bIsNull', false);
					viewmodel.get("inStore_name").setReadOnly(true);
					var inStore = cb.rest.AppContext.user.storeId;
					var proxy = cb.rest.DynamicProxy.create({
				  	settle: {
				  		url: "/bill/ref/getCentWarehouseGroup",
				  		method: "POST" 
				  	} 
				  });
				  var params = {
				    storeId: inStore,
				  };
				  proxy.settle(params, (err, result) => {
			      if (err) {
			        cb.utils.alert(err.message, 'error');
			        return;
			      }
			
			      if(result === undefined) {
			        cb.utils.alert("没有查询所属门店的周边门店业务仓库！", 'error');
			      } else {
			      	
			      	//添加仓库过滤条件只有周边仓库
			      	var conditionWarehouse = {
			      		"isExtend": true,
								simpleVOs: []
			      	};
							conditionWarehouse.simpleVOs.push({
								field: 'id',
								op: 'in',
								value1: result
							});
			      	viewmodel.get('inWarehouse_name').setFilter(conditionWarehouse);
			      }
			    });
				}else{
					viewmodel.get('inStore_name').setState('bIsNull', false);
					viewmodel.get("inStore_name").setReadOnly(false);
				}
			});
			
      
    	//新增行前事件
      // viewmodel.get("details").on("beforeInsertRowFromRefer", function (data) {
      //   let selectedRow = viewmodel.get("details").getSelectedRows()[0];
      //   if (selectedRow) {
      //     let row = data.row;
      //     let keys = Object.keys(selectedRow);
      //     for (let i = 0; i < keys.length; i++) {
      //       let key = keys[i];
      //       row[key] = selectedRow[key];
      //     }
      //   }
      // });
			
			//业务类型为退货申请,当入库仓库值发生改变的时候，给入库组织赋值
			viewmodel.get("inWarehouse_name").on('afterValueChange', function(data) {
				var bustype_storeOutType = viewmodel.get("bustype_storeOutType").getValue();
				if(bustype_storeOutType == 2){
					viewmodel.get("inOrg").setValue(viewmodel.get("inWarehouse_org").getValue());
					viewmodel.get("inOrg_name").setValue(viewmodel.get("inWarehouse_org_name").getValue());
				}
			});
			
			//填写完门店名称后，添加仓库过滤
			viewmodel.get("inStore_name").on('afterValueChange', function(data) {
				if(viewmodel.get("inStore_name").getValue() == null ||viewmodel.get("inStore_name").getValue() == "" ){
					viewmodel.get("inWarehouse_name").setValue();
					viewmodel.get("inOrg").setValue();
					viewmodel.get("inOrg_name").setValue();
				}
				
				var inStore = viewmodel.get("inStore").getValue();
				var isDB = viewmodel.get('bustype_storeOutType').getValue();
				if(isDB == 1){
					viewmodel.get("inOrg").setValue(viewmodel.get("inStore_org").getValue());
					viewmodel.get("inOrg_name").setValue(viewmodel.get("inStore_org_name").getValue());
					
					var proxy = cb.rest.DynamicProxy.create({
				  	settle: {
				  		url: "/bill/ref/getWarehousesDetailFromStore",
				  		method: "POST" 
				  	} 
				  });
				  var params = {
				    storeId: inStore,
				  };
				  proxy.settle(params, (err, result) => {
			      if (err) {
			        cb.utils.alert(err.message, 'error');
			        return;
			      }
			
			      if(result === undefined) {
			        cb.utils.alert("没有查询当前选择店铺的仓库！", 'error');
			      } else {
			      	var arr = [];
			      	for(var i = 0 ; i < result.length ; i ++ ){ 
			      		arr.push(result[i].id);
			      		if(result[i].isDefault = true){
			      			viewmodel.get('inWarehouse').setValue(result[i].id);
			      			viewmodel.get('inWarehouse_name').setValue(result[i].name);
			      		}
			      	}
			      	//添加门店过滤条件只有周边门店
			      	var conditionWarehouse = {
			      		"isExtend": true,
								simpleVOs: []
			      	};
							conditionWarehouse.simpleVOs.push({
								field: 'id',
								op: 'in',
								value1: arr
							});
			      	viewmodel.get('inWarehouse_name').setFilter(conditionWarehouse);
			      }
			    });	
				
				}else{
					
				}
			});
			
    },
    // 查询该店铺所有周边门店
		queryCentStoreGroup : function (storeId,viewmodel) {
		  var proxy = cb.rest.DynamicProxy.create({
		  	settle: {
		  		url: "/bill/ref/getCentStoreGroup",
		  		method: "POST" 
		  	} 
		  });
		  var params = {
		    storeId: storeId,
		  };
		  proxy.settle(params, (err, result) => {
	      if (err) {
	        cb.utils.alert(err.message, 'error');
	        return;
	      }
	
	      if(result === undefined || result == "") {
	        cb.utils.alert("未查到该门店周边门店组或周边门店组只有当前门店！", 'error');
	      	//没有周边门店组，查出来为空
	      	//添加门店过滤条件只有周边门店
	      	var conditionStore = {
	      		"isExtend": true,
						simpleVOs: []
	      	};
					conditionStore.simpleVOs.push({
						field: 'id',
						op: 'in',
						value1: 10010
					});
	      	viewmodel.get('inStore_name').setFilter(conditionStore);

	      } else {
	      	//添加门店过滤条件只有周边门店
	      	var conditionStore = {
	      		"isExtend": true,
						simpleVOs: []
	      	};
					conditionStore.simpleVOs.push({
						field: 'id',
						op: 'in',
						value1: result
					});
	      	viewmodel.get('inStore_name').setFilter(conditionStore);
	      }
	    });
		},
		
		// 退货查询时，入库仓过滤只有业务仓
		setWarehouseFilter : function (viewmodel) {
		  var inStore = cb.rest.AppContext.user.storeId;
			var proxy = cb.rest.DynamicProxy.create({
		  	settle: {
		  		url: "/bill/ref/getCentWarehouseGroup",
		  		method: "POST" 
		  	} 
		  });
		  var params = {
		    storeId: inStore,
		  };
		  proxy.settle(params, (err, result) => {
	      if (err) {
	        cb.utils.alert(err.message, 'error');
	        return;
	      }
	
	      if(result === undefined) {
	        cb.utils.alert("没有查询所属门店的周边门店业务仓库！", 'error');
	      } else {
	      	
	      	//添加门店过滤条件只有周边门店
	      	var conditionWarehouse = {
	      		"isExtend": true,
						simpleVOs: []
	      	};
					conditionWarehouse.simpleVOs.push({
						field: 'id',
						op: 'in',
						value1: result
					});
	      	viewmodel.get('inWarehouse_name').setFilter(conditionWarehouse);
	      }
	    });
		},
		
		// 查询业务类型，并复制默认类型
		queryBusytype : function (type,viewmodel) {
		  var proxy = cb.rest.DynamicProxy.create({
		  	settle: {
		  		url: "/bill/ref/queryBusytype",
		  		method: "POST" 
		  	} 
		  });
		  var params = {
		  	type:type
		  };
		  proxy.settle(params, (err, result) => {
	      if (err) {
	        cb.utils.alert(err.message, 'error');
	        return;
	      }
	
	      if(result === undefined) {
	        cb.utils.alert("没有查询业务类型！", 'error');
	      } else {
	      	//var arr = [];
	      	var type;
	      	for(var i = 0 ; i < result.length ; i ++ ){ 
	      		//arr.push(result[i].id);
	      		if(result[i].isSystem == true || result[i].isDefault == true  ){
	      			viewmodel.get('bustype_name').setValue(result[i].name);
	      			viewmodel.get('bustype').setValue(result[i].id);
	      			viewmodel.get('bustype_storeOutType').setValue(result[i].storeOutType);
	      			
	      			break;
	      		}
	      	}
	      	type = result[0].storeOutType;
	      	var conditionBusytype = {
	      		"isExtend": true,
						simpleVOs: []
	      	};
					conditionBusytype.simpleVOs.push({
						field: 'storeOutType',
						op: 'eq',
						value1: type
					});
	      	viewmodel.get('bustype_name').setFilter(conditionBusytype);
	      }
	    });
		}
  }
	  
  try {
    module.exports = ST_st_storeout_VM_Extend;
  } catch (error) {

  }
  return ST_st_storeout_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storeout_VM.Extend.js